/**
 * Build Setup Location create/edit API payload.
 * Backend persists Location + Threshold from one call via setThreshold/threshold fields.
 */

/**
 * @param {object} form
 * @returns {{ location: object }}
 */
export function buildLocationPayload(form = {}) {
  const setThreshold = !!form.setThreshold;
  const parsedThreshold = Number(form.threshold);
  const location = {
    name: (form.name || '').trim(),
    description: (form.description || '').trim(),
    country: form.country,
    type: form.type,
    setThreshold,
    threshold: setThreshold && Number.isFinite(parsedThreshold) ? parsedThreshold : null,
  };

  if (form.type === 'Other' && form.newtype) {
    location.newtype = form.newtype.trim();
  }

  if (form._id) {
    location._id = form._id;
  }

  return { location };
}
